import React, { useState, useCallback } from "react";
import TriggeredAlertBreakdownChartView from "./TriggeredAlertBreakdownChartView";
import TriggeredAlertBreakdownDrillDownModal from "./TriggeredAlertBreakdownDrillDownModal";
import { usePagesContent } from "../../../Hooks/usePagesContent";
import { CHART_TYPES } from "./chartConfig";

const TriggeredAlertBreakdownChart = ({ startDate, endDate, globalFilters = {} }) => {
  const pagesContent = usePagesContent();
  const [drillDownOpen, setDrillDownOpen]         = useState(false);
  const [selectedDataPoint, setSelectedDataPoint] = useState(null);

  const handleDataPointClick = useCallback((clickedData, currentGroupBy) => {
    setSelectedDataPoint({ ...clickedData, currentGroupBy });
    setDrillDownOpen(true);
  }, []);

  const chartMeta = pagesContent?.metaInfo?.charts?.[CHART_TYPES.TRIGGERED_ALERT_BREAKDOWN];

  if (!pagesContent?.mounted || chartMeta?.enabled === false) return null;

  const title = chartMeta?.title || "Triggered Alert Breakdown";

  return (
    <>
      <TriggeredAlertBreakdownChartView
        title={title}
        height="582px"
        startDate={startDate}
        endDate={endDate}
        globalFilters={globalFilters}
        onDataPointClick={handleDataPointClick}
      />
      <TriggeredAlertBreakdownDrillDownModal
        open={drillDownOpen}
        onClose={() => setDrillDownOpen(false)}
        selectedDataPoint={selectedDataPoint}
        chartTitle={title}
        startDate={startDate}
        endDate={endDate}
        globalFilters={globalFilters}
      />
    </>
  );
};

export default TriggeredAlertBreakdownChart;
